/* eslint-disable */
// This code is autogenerated using @harnessio/oats-cli.
// Please do not modify this code directly.
import type { PaginatedVoiceProfileList } from '../schemas/PaginatedVoiceProfileList';
import { fetcher, FetcherOptions } from './fetcher';

export interface VoiceProfileListAPIQueryParams {
  limit?: number;
  offset?: number;
  ordering?: string;
  /**
   * @format uuid
   */
  organization?: string;
}

export type VoiceProfileListOkResponse = PaginatedVoiceProfileList;

export type VoiceProfileListErrorResponse = unknown;

export interface VoiceProfileListProps
  extends Omit<FetcherOptions<VoiceProfileListAPIQueryParams, unknown>, 'url'> {
  queryParams: VoiceProfileListAPIQueryParams;
}

export function voiceProfileList(
  props: VoiceProfileListProps
): Promise<VoiceProfileListOkResponse> {
  return fetcher<
    VoiceProfileListOkResponse,
    VoiceProfileListAPIQueryParams,
    unknown
  >({
    url: `/voice_profile/`,
    method: 'GET',
    ...props
  });
}
